<div class="subcomponent-inner-wrap">
	<mat-card style="min-height: 500px; font-size: 14px" class="acies-card">
		<mat-card-content>
			<router-outlet></router-outlet>
		</mat-card-content>
	</mat-card>
</div>
